import React from "react";
import {
  Grid,
} from "@mui/material";
import { ReaderRowDTO } from "./types";

export default function InstanceReaderTableRow (entry: ReaderRowDTO, bold = false) {
  const {serial, lastProcessList, appName, appVersion} = entry;
  return (
    <>
      <Grid item xs={1}/>
      <Grid item xs={3} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {serial}
      </Grid>
      <Grid item xs={3} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {lastProcessList}
      </Grid>
      <Grid item xs={2} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {appName}
      </Grid>
      <Grid item xs={2} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {appVersion}
      </Grid>
      <Grid item xs={1}/>
    </>
  );
}